function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.9883 7.96875C21.9023 9.87891 20.5391 12.4883 17.9102 15.8047C15.1914 19.2695 12.8906 21 11.0078 21C9.84375 21 8.85547 19.9453 8.05078 17.8359C7.51172 15.9023 6.97656 13.9688 6.4375 12.0352C5.83984 9.92578 5.19531 8.87109 4.51172 8.87109C4.35938 8.87109 3.83594 9.17969 2.94141 9.79297L2 8.60547C2.98828 7.75781 3.96094 6.90625 4.91797 6.05859C6.23438 4.94141 7.22266 4.35547 7.88281 4.29687C9.4375 4.14844 10.3984 5.19141 10.7578 7.42578C11.1445 9.83203 11.4141 11.332 11.5625 11.918C12.0117 13.9141 12.5078 14.9102 13.0469 14.9102C13.4648 14.9102 14.0938 14.2656 14.9336 12.9688C15.7695 11.6719 16.2188 10.6875 16.2773 10.0078C16.3984 8.89062 15.9492 8.32812 14.9336 8.32812C14.4531 8.32812 13.9609 8.4375 13.4531 8.65234C14.4336 5.49609 16.3125 3.96484 19.0859 4.05078C21.1406 4.10937 22.1094 5.41406 21.9883 7.96875Z",
  fill: "white"
});

var SvgSocialVimeo = function SvgSocialVimeo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSocialVimeo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/social-vimeo.b1fbcdf9.svg";
export { ForwardRef as ReactComponent };